/* ==========================================================================
   CRONE · cx-collection.js – Filter, Sortierung, „Mehr laden“ ohne Neuladen
   ========================================================================== */
(function () {
  'use strict';
  var busy = false;

  function sectionEl() { return document.querySelector('[data-cx-coll]'); }
  function sectionWrap() { var s = sectionEl(); return s && s.closest('.shopify-section'); }

  function paramsFromForm() {
    var form = document.querySelector('[data-cx-filter-form]');
    var p = new URLSearchParams();
    if (form) new FormData(form).forEach(function (v, k) { if (v !== '' && v != null) p.append(k, v); });
    var sort = document.querySelector('[data-cx-sort]');
    if (sort && sort.value) p.set('sort_by', sort.value);
    return p;
  }

  function render(url, push) {
    var wrap = sectionWrap(), sec = sectionEl(); if (!wrap || !sec || busy) return;
    busy = true; sec.classList.add('is-loading');
    var u = new URL(url, location.origin);
    u.searchParams.set('section_id', sec.dataset.section);
    fetch(u.toString()).then(function (r) { return r.text(); }).then(function (html) {
      var keepOpen = document.documentElement.classList.contains('cx-open') && document.getElementById('cx-filters') && document.getElementById('cx-filters').classList.contains('is-open');
      var d = document.createElement('div'); d.innerHTML = html;
      var fresh = d.querySelector('[data-cx-coll]'); if (!fresh) { location.href = url; return; }
      var openGroups = Array.prototype.map.call(document.querySelectorAll('#cx-filters .cx-fgroup'), function (g) { return g.open; });
      sec.replaceWith(fresh);
      if (keepOpen) {
        var f = document.getElementById('cx-filters'); if (f) f.classList.add('is-open');
        Array.prototype.forEach.call(document.querySelectorAll('#cx-filters .cx-fgroup'), function (g, i) { if (openGroups[i] != null) g.open = openGroups[i]; });
      }
      if (push) { u.searchParams.delete('section_id'); history.pushState({ cx: 1 }, '', u.pathname + (u.search ? u.search : '')); }
      if (window.cxRevealRefresh) window.cxRevealRefresh();
      document.dispatchEvent(new CustomEvent('cx:collection-updated'));
    }).catch(function () { location.href = url; }).finally(function () { busy = false; var s = sectionEl(); if (s) s.classList.remove('is-loading'); });
  }

  var t = null;
  document.addEventListener('change', function (e) {
    var f = e.target.closest && e.target.closest('[data-cx-filter-form]');
    if (f) { clearTimeout(t); t = setTimeout(function () { render(location.pathname + '?' + paramsFromForm().toString(), true); }, e.target.type === 'number' ? 600 : 50); return; }
    if (e.target.matches && e.target.matches('[data-cx-sort]')) { render(location.pathname + '?' + paramsFromForm().toString(), true); }
  });
  document.addEventListener('submit', function (e) {
    if (!e.target.matches || !e.target.matches('[data-cx-filter-form]')) return;
    e.preventDefault();
    if (window.CX && CX.close) CX.close(true);
    render(location.pathname + '?' + paramsFromForm().toString(), true);
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-cx-filter-link]');
    if (a) { e.preventDefault(); render(a.href, true); return; }
    var more = e.target.closest && e.target.closest('[data-cx-load-more]');
    if (more) {
      e.preventDefault(); if (busy) return; busy = true; more.classList.add('is-loading');
      var sec = sectionEl(); var u = new URL(more.href, location.origin); u.searchParams.set('section_id', sec.dataset.section);
      fetch(u.toString()).then(function (r) { return r.text(); }).then(function (html) {
        var d = document.createElement('div'); d.innerHTML = html;
        var grid = sec.querySelector('[data-cx-coll-grid]'), ng = d.querySelector('[data-cx-coll-grid]');
        if (grid && ng) Array.prototype.forEach.call(ng.children, function (li) { grid.appendChild(li); });
        var m = sec.querySelector('[data-cx-coll-more]'), nm = d.querySelector('[data-cx-coll-more]');
        if (m) { if (nm) m.replaceWith(nm); else m.remove(); }
        if (window.cxRevealRefresh) window.cxRevealRefresh();
      }).catch(function () { location.href = more.href; }).finally(function () { busy = false; });
    }
  });
  window.addEventListener('popstate', function (e) { if (e.state && e.state.cx) render(location.href, false); else if (sectionEl()) render(location.href, false); });
})();

/* Rasteransicht: 2/3/4 Spalten am Desktop, 1/2 am Handy – wird im Browser gemerkt */
(function () {
  var de = document.documentElement;
  function set(k, v) { de.setAttribute(k, v); try { localStorage.setItem('cx-' + k, v); } catch (e) {} sync(); }
  function sync() {
    var d = de.getAttribute('data-cx-cols') || '4', m = de.getAttribute('data-cx-cols-m') || '2';
    document.querySelectorAll('[data-cx-cols]').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.cxCols === d ? 'true' : 'false'); });
    document.querySelectorAll('[data-cx-cols-m]').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.cxColsM === m ? 'true' : 'false'); });
  }
  try { var d = localStorage.getItem('cx-data-cx-cols'), m = localStorage.getItem('cx-data-cx-cols-m'); if (d) de.setAttribute('data-cx-cols', d); if (m) de.setAttribute('data-cx-cols-m', m); } catch (e) {}
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-cx-cols],[data-cx-cols-m]'); if (!b) return;
    if (b.dataset.cxCols) set('data-cx-cols', b.dataset.cxCols); else set('data-cx-cols-m', b.dataset.cxColsM);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
  document.addEventListener('cx:collection-updated', sync);
})();
